import { combineEpics, ofType } from 'redux-observable';
import { map, catchError, mergeMap } from 'rxjs/operators';

import { LOAD, loadSuccess, loadError } from './actions';

import { createErrorStream } from '../../error';

const load = (action, state, { customerService }) => action.pipe(
  ofType(LOAD),
  mergeMap(action$ => customerService
    .getLogo()
    .pipe(
      map(loadSuccess),
      catchError(createErrorStream(action$, loadError)),
    )),
);

export default combineEpics(
  load,
);
